import { type JSX, PropsWithChildren } from 'react';

import { RowWrap } from './styles';
import { RowProps } from './types';

export const Row = (props: PropsWithChildren<RowProps>): JSX.Element => {
  return <RowWrap {...props} />;
};
